import { render, staticRenderFns } from "./FootprintList.vue?vue&type=template&id=6ef16237&"
import script from "./FootprintList.vue?vue&type=script&lang=js&"
export * from "./FootprintList.vue?vue&type=script&lang=js&"
import style0 from "./FootprintList.vue?vue&type=style&index=0&id=6ef16237&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports